export const CHECKOUT_URL = "https://nail-en.impultienda.ar/checkout/";

export const images = {
  mockup: "https://cdn.magicpatterns.com/uploads/tvME5F31GaxB87qZMg588M/NAIL-EN.png",
  creator: "https://cdn.magicpatterns.com/uploads/thuZC1mvtT6gb1TkgH9gyu/EMILY_CARTER_-_NAIL.png",
};

export const wonderingQuestions = [
  "What should I put in my student workbook?",
  "How should I structure this class?",
  "What should I teach first?",
  "How do I make my course look more professional?",
];

export const beforeItems = [
  "You create every class from zero.",
  "You spend hours organizing your material.",
  "You aren't sure what your students should receive.",
  "Your classes depend heavily on what you remember to explain.",
  "Your materials don't always look as professional as your work.",
  "You know your technique is valuable, but your course doesn't always communicate that value.",
];

export const afterItems = [
  "You start with a proven class structure.",
  "You customize instead of creating from scratch.",
  "Your students receive organized learning materials.",
  "Every class follows a clear teaching flow.",
  "Your course looks more polished and professional.",
  "You can turn your knowledge into a repeatable teaching system.",
];

export const painPoints = [
  {
    title: "You spend too much time preparing your classes",
    text: "You know what you want to teach, but turning your knowledge into a beautiful workbook takes forever.",
  },
  {
    title: "You keep postponing new courses",
    text: "You have techniques you could teach, but creating all the materials makes the process feel overwhelming.",
  },
  {
    title: "You aren't sure how to structure your lessons",
    text: "You know the technique, but you're not always sure what should come before, during and after the demonstration.",
  },
  {
    title: "You want your courses to look worth more",
    text: "You want your students to feel that they're receiving a professional educational experience — not just a few files.",
  },
  {
    title: "You create everything manually",
    text: "Workbooks, checklists, evaluations, certificates, student forms… Every new course means starting all over again.",
  },
  {
    title: "Your expertise is greater than the way your course looks",
    text: "You've invested years into learning nails. Your educational materials should reflect that.",
  },
];

export const volumes = [
  {
    number: "I",
    title: "The Professional Nail Class Blueprint",
    description:
      "Start every class with a clear structure instead of a blank page. Organize the objective, theory, demonstration, practice and evaluation so your students always know what they're learning and why.",
    inside: [
      "Class objectives",
      "Learning outcomes",
      "Lesson structure",
      "Teaching sequence",
      "Instructor preparation checklist",
      "Student preparation checklist",
      "Materials list",
      "Classroom flow",
      "End-of-class review",
    ],
  },
  {
    number: "II",
    title: "Turn Any Nail Technique Into a Complete Lesson",
    description:
      "Take a technique you already know and transform it into an organized lesson your students can follow — with a framework for breaking it down into simple, teachable steps.",
    inside: [
      "Technique breakdown framework",
      "Step-by-step lesson template",
      "Demonstration structure",
      "Practice structure",
      "Instructor talking points",
      "Student notes",
      "Common mistakes section",
      "Troubleshooting section",
      "Practice assignment",
    ],
  },
  {
    number: "III",
    title: "The Student Workbook System",
    description:
      "Give your students something they can actually use during your training. Instead of random notes and screenshots, a structured workbook designed around the learning experience.",
    inside: [
      "Student workbook template",
      "Notes pages",
      "Theory pages",
      "Step-by-step worksheets",
      "Practice pages",
      "Reflection pages",
      "Technique checklists",
      "Progress trackers",
      "Student action plans",
    ],
  },
  {
    number: "IV",
    title: "The Nail Educator Evaluation System",
    description:
      "Stop relying only on “looks good.” Use structured tools to identify what students do correctly, what needs improvement and when they're ready to move forward.",
    inside: [
      "Practical evaluation sheets",
      "Technique scoring sheets",
      "Student progress tracker",
      "Instructor feedback forms",
      "Skills checklist",
      "Final assessment",
      "Improvement plan",
      "Completion checklist",
    ],
  },
  {
    number: "V",
    title: "The Professional Course Experience",
    description:
      "Your students don't only remember what you taught — they remember how the entire experience felt. Create a polished journey from the moment they join until completion.",
    inside: [
      "Welcome guide",
      "Student expectations",
      "Course roadmap",
      "Classroom rules",
      "Materials checklist",
      "Attendance sheet",
      "Progress tracker",
      "Feedback form",
      "Student completion page",
      "Course closing checklist",
    ],
  },
  {
    number: "VI",
    title: "The Certification & Graduation System",
    description:
      "Turn the final stage of your course into a professional experience your students will be proud to share.",
    inside: [
      "Certificate templates",
      "Diploma templates",
      "Completion forms",
      "Student achievement pages",
      "Graduation checklist",
      "Instructor signature pages",
      "Student testimonial request",
      "Social media celebration templates",
    ],
  },
];

export const extras = [
  { title: "Ready-to-customize class templates", text: "Create your next class without staring at a blank Canva page." },
  { title: "Professional checklists", text: "Keep yourself and your students organized throughout the training." },
  { title: "Certification templates", text: "Give students a professional completion experience." },
  { title: "Evaluation tools", text: "Create a more structured way to assess practical skills." },
  { title: "Canva-editable designs", text: "Add your logo, colors, photos, name and branding." },
];

export const bonuses = [
  {
    number: 1,
    title: "100 Premium Nail Certificates",
    value: 47,
    image: "https://cdn.magicpatterns.com/uploads/nQzrB3LWbua1j65iTDddNa/BONU_1_NAIL-EN.png",
    text: "A collection of editable certificate and diploma designs you can customize with your student's name, course, date, logo and signature. Perfect for creating a more premium graduation experience.",
    list: [] as string[],
  },
  {
    number: 2,
    title: "The 30-Minute Class Planner™",
    value: 37,
    image: "https://cdn.magicpatterns.com/uploads/fjtQcmhKLBmjbEYDqH6wEK/BONUS_2_NAIL-EN.png",
    text: "A simple planning system designed to help you organize your next nail class quickly. Use it before teaching to define:",
    list: [
      "What students will learn",
      "What they need",
      "What you'll demonstrate",
      "What they'll practice",
      "How you'll evaluate them",
    ],
  },
  {
    number: 3,
    title: "The Nail Educator Mistake Library",
    value: 39,
    image: "https://cdn.magicpatterns.com/uploads/9aCSccBeiPMvCFKpL1AnAM/BONUS_3_NAIL-EN.png",
    text: "A practical collection of common teaching and class-organization mistakes that can make students feel confused. Use it as a checklist before every class.",
    list: [] as string[],
  },
  {
    number: 4,
    title: "50 Student Feedback & Testimonial Templates",
    value: 37,
    image: "https://cdn.magicpatterns.com/uploads/ocknXCu3CeaCroXQm5ncyE/BONUS_4_NAIL-EN.png",
    text: "Ready-to-edit templates you can use to collect feedback from students and turn great experiences into social proof for your future courses.",
    list: [] as string[],
  },
  {
    number: 5,
    title: "The 30-Page Nail Educator Checklist Pack",
    value: 37,
    image: "https://cdn.magicpatterns.com/uploads/qVfDYmF95XsNSy7x3UxgZv/BONUS_5_NAIL-EN.png",
    text: "A complete collection of checklists covering:",
    list: [
      "Before the class",
      "Student preparation",
      "Materials",
      "Demonstration",
      "Practice",
      "Evaluation",
      "Graduation",
      "Follow-up",
    ],
  },
];

export const offerIncludes = [
  "One-Time Payment",
  "Lifetime Access",
  "No Monthly Fees",
  "Instant Digital Access",
  "Editable with Canva Free or Canva Pro",
];

export const reinventList = [
  "The workbook",
  "The lesson structure",
  "The checklists",
  "The evaluations",
  "The certificates",
  "The student experience",
];

export const testimonials = [
  {
    name: "Sarah M.",
    country: "United States",
    photo: "https://cdn.magicpatterns.com/patterns/generated-images/a72a72d1-5f69-4e2c-bed4-82b6898cc87e.jpg",
    quote:
      "I knew exactly what I wanted to teach, but I had no idea how to organize it into a professional student experience. The templates gave me the structure I was missing.",
  },
  {
    name: "Jessica R.",
    country: "United States",
    photo: "https://cdn.magicpatterns.com/patterns/generated-images/06aba8e2-e525-4f91-9a40-6f87dbfd956d.jpg",
    quote:
      "The biggest difference for me is the amount of time I save. I no longer start every workbook from a blank Canva document.",
  },
  {
    name: "Amanda T.",
    country: "Canada",
    photo: "https://cdn.magicpatterns.com/patterns/generated-images/f4baedea-df9b-4584-ba18-ce97ee6ade74.jpg",
    quote: "My favorite part is being able to customize everything with my own branding. It finally feels like MY course.",
  },
  {
    name: "Nicole B.",
    country: "United States",
    photo: "https://cdn.magicpatterns.com/patterns/generated-images/bbd101ce-16b8-4d7b-88fc-73e589d6fb4e.jpg",
    quote: "I already knew how to teach nails. What I needed was a better system for packaging what I knew.",
  },
  {
    name: "Melissa K.",
    country: "United States",
    photo: "https://cdn.magicpatterns.com/patterns/generated-images/c3f40783-e745-44b3-8f41-34397bccf579.jpg",
    quote:
      "It helped me stop thinking like someone who just performs nail services and start thinking like an educator.",
  },
];

export const faqs = [
  {
    q: "How will I receive Nail Course In A Box™?",
    a: "Immediately after your payment is confirmed, you'll receive access instructions by email.",
  },
  { q: "Do I need Canva Pro?", a: "No. The templates are designed to work with Canva Free or Canva Pro." },
  {
    q: "Can I edit everything?",
    a: "Yes. You can customize the editable templates with your own name, logo, colors, photos, branding and course information.",
  },
  { q: "Can I use it from my phone?", a: "Yes. You can access and edit the materials from your phone, tablet or computer." },
  {
    q: "Is this a recorded course?",
    a: "No. Nail Course In A Box™ is a practical resource system, not a long video course. The goal is to give you ready-to-customize tools you can actually use.",
  },
  {
    q: "Is this only for nail technicians?",
    a: "It's specifically designed for nail educators, instructors and professionals who teach nail techniques.",
  },
  {
    q: "Can I use the templates for multiple classes?",
    a: "Yes. You can customize the framework for different classes and techniques according to the license terms provided with your purchase.",
  },
  { q: "Is this a one-time payment?", a: "Yes. You pay $27 once. There are no monthly subscriptions." },
  {
    q: "What if I don't like it?",
    a: "You're covered by our 7-day guarantee. If you decide Nail Course In A Box™ isn't right for you, you can request a refund within the guarantee period.",
  },
];

export const recentBuyers = [
  { name: "Valentina R.", place: "Bogotá, Colombia" },
  { name: "Camila G.", place: "Guadalajara, Mexico" },
  { name: "Lucía F.", place: "Madrid, Spain" },
  { name: "Daniela M.", place: "Santiago, Chile" },
  { name: "Sofía P.", place: "Buenos Aires, Argentina" },
  { name: "Mariana L.", place: "Lima, Peru" },
  { name: "Gabriela S.", place: "San Juan, Puerto Rico" },
  { name: "Isabella C.", place: "Santo Domingo, Dominican Republic" },
  { name: "Andrea V.", place: "Quito, Ecuador" },
  { name: "Paola H.", place: "Panama City, Panama" },
  { name: "Fernanda T.", place: "Montevideo, Uruguay" },
  { name: "Natalia B.", place: "San José, Costa Rica" },
  { name: "Ximena O.", place: "Guatemala City, Guatemala" },
  { name: "Carolina D.", place: "Barcelona, Spain" },
];
